/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { IBuyboxGetDimensionVariantAvailabilityActionData } from '../../../data-actions/buybox-get-dimension-variants-availability-action';
import { IModalDimensions } from './buybox-product-configure-mfrm';
import { IVariantNameMappingData } from '../mfrm-buybox.props.autogenerated';
import { getCustomizedVariantName } from '../../../Utilities/get-customized-variant-name';
export interface IMfrmSizeViewProps {
    sizeDimensions?: IModalDimensions[];
    preSelection?: IModalDimensions;
    variantAvailibilityList: IBuyboxGetDimensionVariantAvailabilityActionData[];
    outOfStockText: string;
    percentFunc(dimensionPrice: number, discountAmount: number): void;
    addItemClick(
        selectId: string,
        selectedValue: string,
        dropdownId: string,
        selectedDimensionLabel?: string,
        isAddItemClick?: boolean
    ): void;
    variantMappingConfig: IVariantNameMappingData[] | undefined;
}
// tslint:disable-next-line:max-func-body-length
export const BuyBoxSizeRedesignComponent: React.FC<IMfrmSizeViewProps> = props => {
    const { preSelection } = props;
    const isPreSelected = preSelection && preSelection.selectId.length && preSelection.selectedValue.length ? true : false;
    const [selectId, setSelectId] = React.useState<string | undefined>();
    const [preSelectionPending, setPreSelectionPending] = React.useState<boolean>(true);
    const handleKeyPress = (
        e: React.KeyboardEvent<HTMLElement>,
        highlightId: string,
        highlightValue: string,
        highlightDimensionLabel?: string
    ) => {
        if (e.keyCode === 13) {
            updatePricing(highlightId, highlightValue, highlightDimensionLabel, true);
        }
    };
    const updatePricing = (highlightId: string, highlightValue: string, highlightDimensionLabel?: string, isAddItemClick?: boolean) => {
        const selectHighlightId = highlightId;
        const selectedValue = highlightValue;
        const selectedDimensionLabel = highlightDimensionLabel;
        setSelectId(highlightId);
        let discountAmount = 0;
        let dimensionPrice = 0;
        props.sizeDimensions &&
            props.sizeDimensions.map(i => {
                if (preSelectionPending) {
                    if (i.selectedValue === preSelection?.selectedValue) {
                        discountAmount = i.discountAmount || 0;
                        dimensionPrice = i.dimensionPrice || 0;
                    }
                } else {
                    if (i.selectedValue === selectedValue) {
                        discountAmount = i.discountAmount || 0;
                        dimensionPrice = i.dimensionPrice || 0;
                    }
                }
            });
        if (preSelectionPending) {
            if (isPreSelected) {
                props.percentFunc(dimensionPrice, discountAmount);
            }
        } else {
            props.percentFunc(dimensionPrice, discountAmount);
        }
        if (highlightId) {
            selectHighlightId &&
                selectedValue &&
                props.sizeDimensions &&
                props.addItemClick(
                    selectHighlightId,
                    selectedValue,
                    props.sizeDimensions[0].dropdownId,
                    selectedDimensionLabel,
                    isAddItemClick
                );
        } else {
            preSelection &&
                props.sizeDimensions &&
                props.addItemClick(
                    preSelection.selectId,
                    preSelection.selectedValue,
                    props.sizeDimensions[0].dropdownId,
                    preSelection.dimensionLabel,
                    isAddItemClick
                );
        }
    };
    // if a pre-selection was made
    if (preSelection && isPreSelected && preSelectionPending) {
        updatePricing(preSelection.selectId, preSelection.selectedValue, preSelection.dimensionLabel, false);
        setPreSelectionPending(false);
    }
    return (
        <ul className='msc-dimensions'>
            {props.sizeDimensions && props.sizeDimensions.map((dimension: IModalDimensions) => {
                let isAvailable = false;
                for (let idx = 0; idx < props.variantAvailibilityList.length; idx++) {
                    // tslint:disable-next-line: radix
                    const sameSizeVariantsAvailability = props.variantAvailibilityList.filter((variant => variant.sizeDimensionRecordID === parseInt(dimension.selectId, 10)));
                    isAvailable = sameSizeVariantsAvailability.find(variant => variant.isAvailable) ? true : false;
                }
                const isActive = dimension.selectId === selectId;
                if (isActive && isAvailable === false) {
                    const selectedValueData = props.variantAvailibilityList.filter(item => item.sizeValue === dimension.selectedValue);
                    const isVariantAvailableAtAll = selectedValueData.filter(item => item.isAvailable === true)?.length;
                    const isAnyVariantAvailable = props.variantAvailibilityList.filter(item => item.isAvailable === true);
                    if (isVariantAvailableAtAll === 0 && isAnyVariantAvailable.length !== 0) {
                        updatePricing(isAnyVariantAvailable[0].sizeDimensionRecordID.toString(), isAnyVariantAvailable[0].sizeValue, '', true);
                    }
                }
                const customVariantName = getCustomizedVariantName(props.variantMappingConfig, dimension.selectedValue);
                return (
                    <li
                        className={isActive ? 'msc-dimensions-wrapper msc-dimensions-wrapper-active ' : isAvailable ? 'msc-dimensions-wrapper ' : 'msc-dimensions-wrapper msc-dimensions-wrapper-disable'}
                        id={dimension.selectId}
                        key={dimension.selectId}
                        tabIndex={0}
                        data-no-click={!isAvailable}
                        // tslint:disable-next-line: jsx-no-lambda & react-this-binding-issue
                        onClick={() => { dimension.selectId && dimension.selectedValue && updatePricing(dimension.selectId, dimension.selectedValue, dimension.dimensionLabel, true); }}
                        // tslint:disable-next-line: jsx-no-lambda & react-this-binding-issue
                        onKeyUp={(e) => { dimension.selectId && dimension.selectedValue && handleKeyPress(e, dimension.selectId, dimension.selectedValue, dimension.dimensionLabel); }}
                    >
                        <button disabled={!isAvailable} className={`${isActive ? 'active' : ''}`} >{customVariantName ? customVariantName : dimension.selectedValue}</button>
                    </li>
                );
            })}
        </ul>
    );
};